import React from 'react';
import TenderOpeningTable from './TenderOpeningTable';

const HydrocarbonCondensat = ({ refreshTrigger }) => (
  <TenderOpeningTable
    procurementTypeHeader='2'
    refreshTrigger={refreshTrigger}
  />
);

export default HydrocarbonCondensat;
